import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  createUserWithEmailAndPassword,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC04WMeuCfUXIkNMGofAwp3Sh42TShjO0w",
  authDomain: "algarxpress-9c21d.firebaseapp.com",
  projectId: "algarxpress-9c21d",
  storageBucket: "algarxpress-9c21d.firebasestorage.app",
  messagingSenderId: "405341422117",
  appId: "1:405341422117:web:be8f762f4bb959b15575cc",
  measurementId: "G-S74KP7514B"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
// const facebookProvider = new FacebookAuthProvider();

const createUserOnFirebase = async ({ email, password }) => {
  return await createUserWithEmailAndPassword(auth, email, password);
};

// Export everything, including signInWithPopup
export {
  auth,
  googleProvider,
  // facebookProvider,
  signInWithPopup,
  createUserOnFirebase,
};
